import { CustomParameters } from '@accedo/one-plugin-sdk';

export interface CloseHandler {
  onClose: () => void;
  ignoreDefault?: boolean;
  isCancelOnly?: boolean;
}

export interface ShowPaywallParams {
  overrides?: { token?: string; expiration?: string; isLoggedIn?: boolean };
  closeHandler?: CloseHandler;
  customParameters?: CustomParameters;
}

export enum CardStatus {
  Valid = 'valid',
  AboutToExpire = 'aboutToExpire',
  Expired = 'expired',
  NotFound = 'notFound',
}

// TODO: Remove this and fetch these values from config instead
export enum PaymentStore {
  Mpp = 'MPP',
  InPlayer = 'InPlayer',
}
